import React, { useState, useEffect } from 'react'
import './dmdoc.css'
import Sidebar from '../../components/Sidebar/Sidebar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleLeft, faArrowRight, faCopy } from '@fortawesome/free-solid-svg-icons'

import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import { Link,useParams } from 'react-router-dom'
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext'
import BackLoader from '../../components/backloader'
import TopBar from '../../components/topbar'
import { useNavigate } from 'react-router-dom'
import JisAlert from '../../components/jisalert'

function CreateTemplate() {

    const [openSuccess, setOpenSuccess] = useState(false)
    const {id} = useParams();
    const {type}=useParams();

    const tempUrl= `${Constants.apiUrl}/gazette/templates/${id}/details`;
    const holderUrl= `${Constants.apiUrl}/gazette/templateholders`;
    const navlink=type==0?'/templates/affidafits':'/templates/document';
    const [template, setTemplate]=useState({title:''});
    const [holders, setHolders]=useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [html, setHtml] =useState('');
    const [icopy, setICopy] =useState(-1);
    const [alert, setAlert]=useState ({open:false,title:'', subtitle:''});

    const [upHolders, setUpHolders ] =useState([]); //this list is coming from all of them

    const pattern= /\[.+?\]/g
    const isClipboard= (window.isSecureContext && navigator.clipboard);


   /*  const modules = {
        toolbar: [
            [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
            [{ size: [] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }], // text alignment
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['link', 'image', 'video'],
            ['clean']
        ]
    };
    const styles = {
        // Define inline styles for alignment
        'align': {
            'text-align': value => value
        }
    }; */

   /*  ClassicEditor
    .create( document.querySelector( '#editor' ), {
        plugins: [
           // Alignment
        ],
        toolbar: [ 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote','alignment:left', 'alignment:center', 'alignment:right' ],
        heading: {
            options: [
                { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' }
            ]
        },
        uiColor : '#AADC6E'

    } )
    .catch( error => {
        console.log( error );
    } ); */


    useEffect(() => {
        
        if(id!=null){
            LoadTemplate();
        }
        LoadHolders();
    
  }, [id])
  

  const LoadTemplate=()=>{
    setIsLoading(true);
    fetch(tempUrl, {
        method: 'GET',
        headers: {
          'Content-type': 'application/json',
        },
      })
        .then((resp) => resp.json())
        .then((data) => {
            setIsLoading(false);
            if(data.code==0){
                setTemplate(data.template);
             // setHtml(atob(data.template.html))  ;
setHtml(Constants.b64decode(data.template.html))  ;
              setHolders(data.holders);
            }
            
        })
        .catch(error => {
            console.error(error);
            setIsLoading(false);
        })
}

const onTapCopy =(index)=>{
    const ho=upHolders[index];

    // if (window.isSecureContext && navigator.clipboard) {
      navigator.clipboard
      .writeText(ho.placeHolder)
      .then(() => {
       // setBttnText("COPIED");
        setICopy(index);
        setTimeout(function () {
          //setBttnText("COPY CODE");
          setICopy(-1);
        }, 3000);
      })
      .catch((err) => {

        console.log(err.message);
      });
    /* } else {
      
      try {
        document.execCommand(ho.placeHolder);
        setICopy(index);
        setTimeout(function () {
          //setBttnText("COPY CODE");
          setICopy(-1);
        }, 3000);
        console.log('just without https')
      } catch (err) {
        console.error('Unable to copy to clipboard', err);
      }
    } */
    

}

const onSaveTemplate =async()=>{
    //write the txt to pdf
   // setIsDialog(false)
    //this will save only item added

    try {
        const theurl=id==null? `${Constants.apiUrl}/gazette/saveTemplate`:`${Constants.apiUrl}/gazette/saveTemplate/${id}`;
        setIsLoading(true);
        var b4=Constants.b64encode(html); //btoa(html) ;
        //holdersid are the ids on the selected 
        //first get out all the Placeholder in the html text
        var holdersId=new Set();
        console.log('html content');
        console.log(html);
        var ttag= html.match(pattern);
        if (ttag!=null ){
          const tags = Array.from(html.match(pattern))
          console.log('all availble tags')
          console.log(tags);
          //second retrieve all its of the selected placeholder
          //save that on.
          

          for (let index = 0; index < tags.length; index++) {
              const did = tags[index];
              var cc= upHolders.filter((c) => c.placeHolder ==did);
              if(cc.length>0){
                  holdersId.add(cc[0].id);
              }
              
          }
        }
        
        console.log('tmeplate object goin to server');
        console.log(template);
        var temp={template:{...template, html:b4,type: type=='document'?1:0 }, holdersId:Array.from(holdersId)}
        console.log(temp);
    


        const resp = await fetch(theurl, {
          method: 'POST',
          body: JSON.stringify(temp),
          headers: {
            'Content-Type': 'application/json',
            'Authorization': '',
          },
        });
        
        const responseData = await resp.json();
        setIsLoading(false);
        console.log(responseData);
        if (responseData.code === 0 ) {
          //on this back
          setOpenSuccess(true)
            
        }else {
            setAlert(  {open:true,title:'Template', subtitle:responseData.status, onOk});
        }
      } catch (error) {
        setIsLoading(false);
        console.error(error);
       
      }
}

const LoadHolders=()=>{
    setIsLoading(true);
    fetch(holderUrl, {
        method: 'GET',
        headers: {
          'Content-type': 'application/json',
        },
      })
        .then((resp) => resp.json())
        .then((data) => {
            setIsLoading(false);
            if(data.code==0){
               
                setUpHolders(data.holders);
            }
            
        })
        .catch(error => {
            console.error(error);
            setIsLoading(false);
        })
}


const onOk=()=>{
    setAlert({open:false});
}

//Text direction
Quill.register(Quill.import("attributors/style/direction"), true);
//Alignment
Quill.register(Quill.import("attributors/style/align"), true);

// Don't forget corresponding css
const Size = Quill.import("attributors/style/size");
Size.whitelist = ["0.75em", "1em", "1.5em", "2.5em"];
Quill.register(Size, true);

//Text indent
const Parchment = Quill.import("parchment");
class IndentAttributor extends Parchment.Attributor.Style {
  add(node, value) {
    if (value === 0) {
      this.remove(node);
      return true;
    } else {
      return super.add(node, `${value}em`);
    }
  }
}

let IndentStyle = new IndentAttributor("indent", "text-indent", {
  scope: Parchment.Scope.BLOCK,
  whitelist: ["1em", "2em", "3em", "4em", "5em", "6em", "7em", "8em", "9em"]
});

Quill.register(IndentStyle, true);

const modules = {
  // https://github.com/quilljs/quill/issues/2905#issuecomment-683128521
  clipboard: {
    matchVisual: false
  },
  toolbar: [
    [
      { size: ["0.75em", "1em", "1.5em", "2.5em"] },
      "bold",
      "italic",
      "underline",
      { color: [] },
      { background: [] },
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
      { align: [] },
      "link"
    ]
  ]
};


  return (
    <div className='dm-doc-create'>
        <Sidebar />
        <div className="body">
            
            <TopBar title="Home/Template" />
            <div className="back" onClick={() => window.history.back()}>
                <Link><FontAwesomeIcon icon={faAngleLeft} /> Back</Link>
            </div>
            <div className="write-up-box">
                <div className="content-edit">
                    <div className="dashboard-view">
                        <h2>Content Editor</h2>
                        <div className="form-inp">
                            <label htmlFor="templateName">Title of Template</label>
                            <input type="text" placeholder='Enter Template Name' id='templateName' value={template.title} onChange={(e)=> setTemplate({...template,title:e.target.value}) } />
                        </div>

                       {/*  <div className="tick-box">
                            <input type="checkbox" id='cansign'/>
                            <label htmlFor="cansign">Please tick this box if deponent can sign before payment is made</label>
                        </div>
                        <div className="tick-box">
                            <input type="checkbox" id='canseal'/>
                            <label htmlFor="canseal">Please tick this box if deponent can add seal before payment is made</label>
                        </div> */}
                        <div className="quill-box">
                       
                            {/* <ReactQuill name='' id='' placeholder='Type here...' className='quill'  modules={modules}
                                formats={formats}
                                value={editorHtml}
                                onChange={handleChange} theme="snow" /> */}
                                <ReactQuill
                                     value={html} 
                                    onChange={(e)=>{setHtml(e); console.log(e)}}
                                    modules={modules}
                                   /*  style={styles} */
                                    bounds={`[data-text-editor="form-editor"]`}
                                />
                        </div>
                        <div className="form-inp">
                            <label htmlFor="templateName">Description</label>
                            <input type="text" placeholder='Enter Description Note' id='templateNote' value={template.note} onChange={(e)=> setTemplate({...template,note:e.target.value}) } />
                        </div>
                        <div className="sep-btns">
                            <Link><button className='black'>Back</button></Link>
                            <button className='red' onClick={onSaveTemplate }>{id==null?'Create Template':'Update Template'}  <FontAwesomeIcon icon={faArrowRight} /></button>
                        </div>
                    </div>
                </div>
                <div className="copy-paste">
                    <div className="dashboard-view">
                        <h2>Copy And Paste Placeholder To Editor</h2>
                        
                        <div className="placeholders">
                           {
                                upHolders.map((ho, i) => { return (
                                    <div className="place-copy" key={i}>
                                <p>{ho.name}</p>
                               {isClipboard ? <div className="tap-copy" onClick={()=> onTapCopy(i)}>
                                    <p>{icopy==i?'COPIED':'Tap to Copy'} </p>
                                    <FontAwesomeIcon icon={faCopy} />
                                </div>:<div className="manual-copy" >
                                    <p>{ho.placeHolder} </p>
                                   
                                </div>} 

                            </div>
                                )})
                            } 
                            

                            <div className="back-to-create">
                                <Link to='/templates/placeholders'>
                                    <FontAwesomeIcon icon={faAngleLeft} />
                                    <p>Goto Placeholders Setup</p>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           {openSuccess && <div className={ "success open" }>
                <div className="success-box">
                    <h2>{id==null?'Create Template':'Update Template'}</h2>
                    <p> {id==null?'Create Template':'Update Template'}  successful</p>
                    <Link to={navlink}><button className='red'>Continue</button></Link>
                </div>
            </div>} 
          {alert.open && <JisAlert {...alert}/>}  
            <div className="footer-tech">
                <p>Powered By First Hightower InfoTech</p>
                <p>© 2024</p>
            </div>
        </div>
    </div>
  )
}

export default CreateTemplate